// removed by extract-text-webpack-plugin
module.exports = {"posttagcontainer":"src-components-PostTags----PostTags-module---posttagcontainer---2jLsS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PostTags/PostTags.module.scss
// module id = 426
// module chunks = 213130420965792